export interface UserLimits {
  user_pause: number;
  user_pause_at: string;
  user_pause_in: string;
  user_pause_min: number;

  user_exclusion: number;
  user_exclusion_at: string;
  user_exclusion_in: string;
  user_exclusion_min: number;

  type?: string;
  status: number;

  user_limit_deposit: number;
  user_limit_deposit_active: number;
  user_limit_deposit_period: number;
  user_limit_deposit_change: string;
  user_limit_deposit_finish_period: string;
  user_limit_deposit_next_amount_change: number;
  user_limit_deposit_next_amount_change_requested_at: string;
  user_limit_deposit_next_period_change: number;

  user_limit_bet: number;
  user_limit_bet_active: number;
  user_limit_bet_period: number;
  user_limit_bet_change: string;
  user_limit_bet_finish_period: string;
  user_limit_bet_next_amount_change: number;
  user_limit_bet_next_amount_change_requested_at: string;
  user_limit_bet_next_period_change: number;

  user_limit_loss: number;
  user_limit_loss_active: number;
  user_limit_loss_period: number;
  user_limit_loss_change: string;
  user_limit_loss_finish_period: string;
  user_limit_loss_next_amount_change: number;
  user_limit_loss_next_amount_change_requested_at: string;
  user_limit_loss_next_period_change: number;

  user_limit_time: string;
  user_limit_time_active: number;
  user_limit_time_period: number;
  user_limit_time_change: string;

  operator_limit_period: number;
  operator_limit_bet: string;
  operator_limit_time: string;
  operator_limit_loss: string;
  operator_limit_deposit: string;

  operator_exclusion: number;
  operator_exclusion_at: string;
  operator_exclusion_note: string;

  spa_exclusion: number;
  spa_exclusion_at: string;
  spa_exclusion_note: string;

  spa_limit_period: number;
  spa_limit_bet: number;
  spa_limit_time: string;
  spa_limit_loss: number;
  spa_limit_deposit: number;
}

export interface UserPendingLimits {
  user_limits: {
    time?: {
      user_limit_time?: string;
      user_limit_time_active: number;
      user_limit_time_period?: number;
    };
    loss?: {
      user_limit_loss?: number;
      user_limit_loss_active: number;
      user_limit_loss_period?: number;
    };
  };
}

export interface UserLimit {
  active: number;
  period: string;
  amount: number;
}

export interface UserLimitTime {
  active: number;
  period: string;
  amount: {
    month?: number;
    day?: number;
    hour?: number;
    minute?: number;
  };
}

export type UserLimitPayload = Partial<UserLimits> & {
  kyc_id?: number;
  password_check?: string;
};

export interface SelfExclusionPayload {
  user_exclusion: number;
  reason: number;
  kyc_id?: number;
  password_check?: string;
}

export interface TimeoutLimitsPayload {
  user_pause: number;
  reason: number;
  kyc_id?: number;
  password_check?: string;
}

export const AccountProtectionAccordion = {
  Deposit: 'accordion-deposit',
  Bet: 'accordion-bet',
  Loss: 'accordion-loss',
  Time: 'accordion-time',
  Timeout: 'accordion-timeout',
  Exclusion: 'accordion-exclusion',
  CentralizedExclusion: 'accordion-centralized-exclusion',
} as const;

export type AccountProtectionAccordions =
  (typeof AccountProtectionAccordion)[keyof typeof AccountProtectionAccordion];

export const MORE_OPTIONS_ACCORDIONS: AccountProtectionAccordions[] = [
  AccountProtectionAccordion.Timeout,
  AccountProtectionAccordion.Exclusion,
  AccountProtectionAccordion.CentralizedExclusion,
];
